import OutputNode from './OutputNodeContainer'

export default OutputNode
